import i18n from "../../i18n";

import {User} from "../../model/User";
import {UserProfile} from "../../model/user/profile/UserProfile";
// const API_URL = "http://localhost:8081/graphql";
const API_URL= process.env.REACT_APP_LOGIN_SERVICE_BASE_URL || '';

export async function findUserProfile(token: string): Promise<UserProfile | null> {
    if (!token) {
        console.error("No token available");
        return null;
    }

    try {
        // Fetch user profile once user is authenticated
        const response = await fetch(API_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`, "Accept-Language": i18n.language || "pt",
            },
            body: JSON.stringify({
                query: `
                    query {
                        findUserSettings {
                            id
                            email
                            firstName
                            lastName 
                            image 
                            phoneNumber
                            language
                            creditCards {
                              cardNumber
                              cardHolderName
                              expirationDate
                              billingInformation {
                                address1
                                address2
                                city
                                state
                                zipCode
                                country
                              }
                            }
                            address {
                              address1
                              address2
                              city
                              state
                              zipCode
                              country
                              isPrimary
                            }
                          }
                    }
                `,
            }),
        });

        const result = await response.json();

        if (result.errors) {
            console.error("GraphQL Errors:", result.errors);
            return null;
        } else if (result?.data?.findUserSettings) {
            return result.data.findUserSettings as UserProfile;
        } else {
            console.error("No data found");
            return null;
        }
    } catch (error) {
        console.error("Error fetching business data:", error);
        return null;
    }
}

async function saveProfile(profileData: UserProfile, token: string) {

    if (!token) {
        console.error("No token available");
        return { success: false, error: "Authentication token is missing" };
    }

    const mutation = `
        mutation saveProfile($input: UserProfileInput!) {
            saveProfile(input: $input) {
                id
                email,
                firstName
                lastName
                image
                phoneNumber
                language
                creditCards {
                  cardNumber
                  cardHolderName
                  expirationDate
                  billingInformation {
                    address1
                    address2
                    city
                    state
                    zipCode
                    country
                  }
                }
                address {
                  address1
                  address2
                  city
                  state
                  zipCode
                  country
                  isPrimary
                }
            }
        }
    `;

    try {
        const response = await fetch(API_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`, "Accept-Language": i18n.language || "pt",
            },
            body: JSON.stringify({
                query: mutation,
                variables: {
                    input: profileData
                },
            }),
        });

        const result = await response.json();
        if (result.errors) {
            console.error('GraphQL Errors:', result.errors);
            return { success: false, error: result.errors };
        } else {
            console.log('Profile saved successfully:', result.data.saveProfile);
            return { success: true, data: result.data.saveProfile };
        }
    } catch (error) {
        console.error("Error saving profile data:", error);
        return { success: false, error: error };
    }
}

export { saveProfile };